<template>
	<div class="text-xs bg-grey-1 rounded-2xl max-w-217 mb-6">
		<div v-if="paymentInformationStatus == 'loading'" class="flex justify-center items-center py-6">
			<Loader size_prop="10em"></Loader>
		</div>

		<div v-else>
			<div class="p-6">
				<div class="text-grey mb-3">Payment Method</div>

				<div class="flex justify-between items-center mb-1">
					<div v-if="$store.getters.paymentMethod == 'rped'">Digital Gold Participant Account No. (RPED)</div>
					<div v-if="$store.getters.paymentMethod == 'gopay'">No. E-wallet</div>

					<div v-if="$store.getters.paymentMethod == 'gopay' && !$store.getters.isGopayLinked">Tidak Tersedia</div>
					<div v-else>{{ paymentInformation.trade_acc.account_number }}</div>
				</div>

				<div class="flex justify-between items-center mb-3">
					<div v-if="$store.getters.paymentMethod == 'rped'">RPED Provider Bank</div>
					<div v-if="$store.getters.paymentMethod == 'gopay'">Nama Layanan</div>

					<div v-if="$store.getters.paymentMethod == 'gopay' && !$store.getters.isGopayLinked">Tidak Tersedia</div>
					<div v-else>
						<span class="">{{ paymentInformation.trade_acc.bank_name }}</span>
						<!-- <img :src="require('@/assets/logo/bank/bank-agi-2.png')" alt="" class="w-5 h-5 ml-2"> -->
					</div>
				</div>

				<div class="flex justify-between items-center mb-1">
					<div>Withdrawal Account Number</div>
					<div>{{ paymentInformation.withdrawal_acc[0].account_number }}</div>
				</div>

				<div class="flex justify-between items-center">
					<div>Withdrawal Account Bank</div>
					<div>
						<span class="uppercase">{{ paymentInformation.withdrawal_acc[0].bank_name }}</span>
						<!-- <img :src="require('@/assets/logo/bank/bank-agi-2.png')" alt="" class="w-5 h-5 ml-2"> -->
					</div>
				</div>

				<div v-if="$store.getters.paymentMethod == 'gopay' && !$store.getters.isGopayLinked"
					class="flex gap-3 bg-white-2 py-2 px-4 mt-3">
					<div>
						<IconInfo2 height_prop="1.25rem" width_prop="1.25rem" />
					</div>

					<div class="text-xs text-black">
						Lakukan order beli emas untuk dapat menampilkan informasi No. E-Wallet dan Nama Layanan
					</div>
				</div>
			</div>

			<hr class="border-2 border-transparent border-grey-4 my-0">

			<div class="p-6">
				<div class="text-grey mb-2">HIN</div>

				<div class="flex justify-between items-center mb-2">
					<div>Holder Identification Number (HIN)</div>
					<div>
						<span class="mr-2">{{ $store.getters.getHin }}</span>
						<IconCopy class="cursor-pointer" @click.native="copyToClipboard($store.getters.getHin)" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getPaymentInformation } from '@/api/payment-information'

import IconCopy from '../../../components/icons/IconCopy.vue'
import IconInfo2 from '../../../components/icons/IconInfo2.vue'
import Loader from '@/components/Loader.vue'

export default {
	name: 'SettingKepemilikan',

	components: {
		IconCopy,
		Loader,
		IconInfo2
	},

	data() {
		return {
			paymentInformation: {},
			paymentInformationStatus: 'idle',
		}
	},

	computed: {
	},

	created() {
		this.getPaymentInformation()
	},

	methods: {
		async copyToClipboard(value) {
			await navigator.clipboard.writeText(value)
		},

		async getPaymentInformation() {
			this.paymentInformationStatus = 'loading'

			const response = await getPaymentInformation({
				user_id: this.$store.state.userId
			})

			this.paymentInformation = response.data.data.body

			this.paymentInformationStatus = 'success'
		},
	},
}
</script>

<style scoped></style>